"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViralEnhancers = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var OrOptions_1 = require("../../inputs/OrOptions");
var SelectOption_1 = require("../../inputs/SelectOption");
var CardName_1 = require("../../CardName");
var ResourceType_1 = require("../../ResourceType");
var DeferredAction_1 = require("../../deferredActions/DeferredAction");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var ViralEnhancers = (function (_super) {
    __extends(ViralEnhancers, _super);
    function ViralEnhancers() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VIRAL_ENHANCERS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 9,
            metadata: {
                cardNumber: '074',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.plants(1, { played: Options_1.played }).slash().microbes(1, { played: Options_1.played }).slash().animals(1, { played: Options_1.played }).br;
                    b.effect('When you play a Plant, Microbe, or an Animal tag, including this, gain 1 plant or add 1 resource to THAT CARD.', function (eb) {
                        eb.empty().startEffect;
                        eb.plants(1).slash().microbes(1).asterix().slash().animals(1).asterix();
                    });
                }),
            },
        }) || this;
    }
    ViralEnhancers.prototype.onCardPlayed = function (player, card) {
        var resourceCount = card.tags.filter(function (tag) { return tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE; }).length;
        if (resourceCount === 0) {
            return undefined;
        }
        if (card.resourceType !== ResourceType_1.ResourceType.ANIMAL && card.resourceType !== ResourceType_1.ResourceType.MICROBE) {
            player.plants += resourceCount;
            return undefined;
        }
        for (var i = 0; i < resourceCount; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, function () { return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Add resource to card ' + card.name, 'Add resource', function () {
                player.addResourceTo(card);
                return undefined;
            }), new SelectOption_1.SelectOption('Gain plant', 'Save', function () {
                player.plants++;
                return undefined;
            })); }));
        }
        return undefined;
    };
    ViralEnhancers.prototype.play = function () {
        return undefined;
    };
    return ViralEnhancers;
}(Card_1.Card));
exports.ViralEnhancers = ViralEnhancers;
